import { Box } from '@mui/material';
import React, { useCallback } from 'react';
import { Model } from 'survey-core';
import { Survey } from 'survey-react-ui';
import 'survey-core/defaultV2.min.css';
import { WsButton } from 'wisestep-base';

import { findSurveyResponse } from './CommonResponse';
import { themeJSON } from './theme';

interface SurveyFeedbackProps {
  feedbackDataBack: (data: any) => void;
  callShowBackInterviewerList: () => void;
  surveyJson: any;
}

const SurveyFeedComponent: React.FC<SurveyFeedbackProps> = ({
  feedbackDataBack,
  callShowBackInterviewerList,
  surveyJson,
}) => {
  const survey = new Model(surveyJson);
  survey.widthMode = 'responsive';
  survey.applyTheme(themeJSON);

  const handleSurveyComplete = useCallback(() => {
    const feedbackData = {};
    for (const key in survey.data) {
      const question = survey.getQuestionByName(key);
      if (question) {
        feedbackData[question.title] = question.value;
      }
    }
    let elementList: any[] = [];

    if (surveyJson.pages.length > 1) {
      surveyJson.pages.map((page, pageIndex) => {
        page.elements.map((_, elementIndex) => {
          elementList.push(surveyJson.pages[pageIndex].elements[elementIndex]);
        });
      });
    } else {
      elementList = surveyJson.pages[0].elements;
    }
    feedbackDataBack(findSurveyResponse(elementList, feedbackData));
  }, [survey, feedbackDataBack]);

  survey.onComplete.add(handleSurveyComplete);

  const handleBackButtonClick = () => {
    callShowBackInterviewerList();
  };

  return (
    <Box style={{ position: 'relative', maxWidth: '600px', margin: 'auto' }}>
      <Survey model={survey} />
      <Box
        style={{
          position: 'absolute',
          top: '10px',
          right: '10px',
          zIndex: 1,
        }}
      >
        <WsButton variant="outlined" onClick={handleBackButtonClick}>
          Back
        </WsButton>
      </Box>
    </Box>
  );
};

export default SurveyFeedComponent;
